import styled from 'styled-components';

import { P } from '../../typography';

/* ------------------------- StyleTokenSection -------------------------- */

/**
 * Title
 *
 * Styled paragraph
 */
export const Title = styled(P)`
    line-height: 1;
    margin-bottom: 1rem;
`;

/**
 * ErrorDisplay
 *
 * Styled paragraph
 */
export const ErrorDisplay = styled(P)(
    ({ theme }) => `
    color: ${theme.sections.negative};
    margin-top: 1.5rem;
`,
);

/**
 * BusyDisplay
 *
 * Styled paragraph
 */
export const BusyDisplay = styled(P)(
    ({ theme }) => `
    color: ${theme.sections.positive};
    margin-top: 1.5rem;
`,
);

/**
 * StyleTokenSection
 *
 * Container for the input fields
 */
export const FormDisplay = styled.div`
    img {
        display: block;
        margin: 0 auto 2rem;
    }
`;

/**
 * StyleTokenSection
 *
 * Container for the input fields
 */
export const StyleTokenSection = styled.div`
    > a {
        position: fixed;
        top: 3rem;
        left: 2rem;
        text-decoration: none;

        @media (hover: hover) {
            &:hover {
                color: ${({ theme }) => theme.sections.page.feature};
            }
        }
    }

    > div {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    ${FormDisplay} {
        form {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;
